export const truncateString = (str?: string | null, num?: number) => {
  if (!str) return ''
  if (!num) return str

  if (str.length <= num) {
    return str
  }
  return `${str.slice(0, num)}...`
}

/**
 * Extracts the username portion from a Mac Mini friendly_id
 * Example: "macmini-2.local-A1M3P14" -> "A1M3P14"
 */
export const extractMacMiniUsername = (friendlyId: string): string => {
  return friendlyId.split('-').pop()?.toUpperCase() || friendlyId
}
